import React from "react";

export default function FAQ() {
  return (
    <section className='faq'>
      <div>
        <h2>Frequent Asked Questions:</h2>
        <h3> 1 - Do I need to create an account to make a search?</h3>
        <p>
          "No. In order to use the app you don't need to have an account."
        </p>
        <h3> 2 - Who needs to create an account?</h3>
        <p>
          "Only restaurants will need to create an account in order to create its own list of dishes and add tags."
        </p>
        <h3> 3 - How many tags can I use for the search?</h3>
        <p>
          "You have the maximum of five tags for your dietary restrictions and a price range, to use to do your research for dishes. There are currently seventeen tags you can choose from."
        </p>
        <h3> 4 - As a restaurant, how can I update my account?</h3>
        <p>
          "Log into your account then click on the 'Welcome' message. That will take you to your own page with all your information. On that page, click on 'Update'. You will be able to update your name and/or phone number."
        </p>
        <h3> 5 - I am a user, and I would like to save my dishes in a favorite list. How can I do it?</h3>
        <p>
          "The 'User Login' part of <i>Foodora</i> is coming very soon, with it you will be able to save your favorite dishes and also leave reviews of all dishes you have tried. Stay tunned!"
        </p>
      </div>
    </section>
  );
}
